import React, { Component } from 'react'
import { headers, api_url } from '../../common/config';

class ImageCarousel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            img_url: ''
        }
    }

    componentDidMount = () => {
        fetch(
            `${api_url}/autism/files/${this.props.image}`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    img_url: res.data.data.full_url
                })
            });
    }

    render() {
        return (
            <div className='img' style={{
                backgroundImage: `url(${this.state.img_url})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundColor: '#ffffff',
            }}>
            <div className='fade'></div>
        </div>
        )
    }
}

export default ImageCarousel